import { RootState } from "..";
import { combineReducers } from "@reduxjs/toolkit";
import coinFlipTableSlice from "./coinFlipTableStore";
import coinFlipSlice from "./Database/coinFlipStore";
import coinFlipProfileSlice from "./Profile/coinProfileStore";

// export selectors
export const selectCoinTable = (state: RootState) => state.coinFlip.tables

export const selectCoinState = (state: RootState) => state.coinFlip.entity

export const selectCoinProfile = (state: RootState) => state.coinFlip.profile

export const coinFlipReducer = combineReducers({
  tables: coinFlipTableSlice,
  entity: coinFlipSlice,
  profile: coinFlipProfileSlice,
});
